import React, { useEffect, useState } from 'react';
import { Block } from '@guryou/html-components';
import ChooseProviderType from './ChooseProviderType';
import ProviderGeneralInfo from './ProviderGeneralInfo';
import SuccessPage from './SuccessPage';

const RegisterRimini = () => {
  const [state, setState] = useState({
    submitted: false,
  });

  const [step, setStep] = useState(1);

  useEffect(() => {
    window.history.replaceState({ step: 1 }, '');

    const handlePopState = event => {
      if (event.state?.step) {
        setStep(event.state.step);
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const goToStep = newStep => {
    setStep(newStep);
    window.history.pushState({ step: newStep }, '');
  };

  return (
    <Block
      display="flex"
      minHeight="100vh"
      maxHeight="100vh"
      xs={12}
      overflowY="auto"
      alignItems="start"
      justifyContent="center"
      margin={0}
      padding={8}
      background="linear-gradient(to bottom, #f0f7ff, #ffffff)"
    >
      {step === 1 && <ChooseProviderType state={state} setState={setState} goToStep={goToStep} />}
      {step === 2 && <ProviderGeneralInfo state={state} setState={setState} goToStep={goToStep} />}
      {step === 3 && <SuccessPage state={state} setState={setState} goToStep={goToStep} />}
    </Block>
  );
};

export default RegisterRimini;
